export const strings = {
  urls: {
    ISSUE_FORM: "https://forms.gle/guUdGtFadGM7aj866",
    FEATURE_FORM: "https://forms.gle/WiRZtomLRx1GPULz6",
    THOUGHT_FORM: "https://forms.gle/Zz5ADc9FpCgu8ZJ89",
  },
};
